// Hosts Loan Number Check + Investment Amount Check results (both are the
// same preflight.py CheckResult shape PreflightPanel.js already renders -
// see check_loan_number_check()/check_investment_amount_check()), stacked,
// via the shared CheckResultCard.

import React, { useEffect, useState, useCallback } from 'react';
import axiosWithAuth from '../../../helpers/AxiosHelper';
import { readErrorDetail } from '../jobs';
import CheckResultCard from '../CheckResultCard';
import LoadingState from '../../common/LoadingState';
import errorMessage from '../../../helpers/errorMessage';

const DataQualityControlPanel = ({ reportingId, setLoading, onChange, onJumpToRow }) => {
  const [loanNumberCheck, setLoanNumberCheck] = useState(null);
  const [investmentAmountCheck, setInvestmentAmountCheck] = useState(null);
  const [error, setError] = useState(null);

  const fetchChecks = useCallback(async () => {
    if (!reportingId) return;
    setLoading(true);
    try {
      const [loanNumberRes, investmentAmountRes] = await Promise.all([
        axiosWithAuth.get(`/compartment-report/reportings/${reportingId}/loan-number-check/result`),
        axiosWithAuth.get(`/compartment-report/reportings/${reportingId}/investment-amount-check/result`),
      ]);
      setLoanNumberCheck(loanNumberRes.data);
      setInvestmentAmountCheck(investmentAmountRes.data);
      setError(null);
      if (onChange) onChange({ loanNumberCheck: loanNumberRes.data, investmentAmountCheck: investmentAmountRes.data });
    } catch (err) {
      console.error('[DataQualityControlPanel] fetch error:', errorMessage(err));
      setError(readErrorDetail(err, 'Failed to load Data Quality Control checks.'));
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportingId]);

  useEffect(() => {
    fetchChecks();
  }, [fetchChecks]);

  return (
    <div>
      {error && <div className="ex-inline-error mb-3">{error}</div>}
      {!loanNumberCheck && !investmentAmountCheck ? (
        !error && <LoadingState label="Loading data quality control checks" />
      ) : (
        <>
          <CheckResultCard check={loanNumberCheck} onJumpToRow={onJumpToRow} />
          <CheckResultCard check={investmentAmountCheck} onJumpToRow={onJumpToRow} />
        </>
      )}
    </div>
  );
};

export default DataQualityControlPanel;
